import React from "react";

function TableTextCell(props) {
  const { text } = props;
  return <div className="text">{text}</div>;
}

export default TableTextCell;
